// Module
var code = "<svg viewBox=\"0 0 49.07 13.14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m41.51 0-.99 1.13 5.42 4.77h-45.94v1.5h45.89l-5.36 4.6.98 1.14 7.56-6.49z\"/></svg>";
// Exports
module.exports = code;